import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f0d1514a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_3 = {
    key: 0,
    class: "wp-resources-wrapper"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "wp-rigth-block-title" }, "Resources", -1));
const _hoisted_5 = { class: "wp-resources-links" };
const _hoisted_6 = ["href"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _hoisted_1,
        _hoisted_2,
        (_ctx.testPage.resources && _ctx.testPage.resources.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testPage.resources, (link) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: link.label
                        }, [
                            _createElementVNode("a", {
                                href: link.link,
                                target: "_blank"
                            }, _toDisplayString(link.label), 9, _hoisted_6),
                            _hoisted_7,
                            _hoisted_8
                        ], 64));
                    }), 128))
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
